import { ReactNode } from 'react';

import { Box, Skeleton, Stack } from '@mui/material';

import { DEFAULT_PAGE_SIZE } from './constants';

export const RenderEmptyState = ({ text }: { text: string | ReactNode }) => {
  return (
    <Stack
      height="72px"
      alignItems="center"
      justifyContent="center"
      boxShadow="inset 0px -1px 0px hsla(0, 0%, 93%, 1)"
    >
      {text}
    </Stack>
  );
};

export const LoadingComponent = ({ columns }: any) => {
  return (
    <>
      {Array.from({ length: DEFAULT_PAGE_SIZE }).map((_, i) => (
        <Box
          key={JSON.stringify(`${i}-skeleton`)}
          display="flex"
          padding="16px"
          sx={{
            height: 'max-content',
            gap: 1,
          }}
          data-testid="skeleton-row"
        >
          {columns?.map((column: any, idx: number) => (
            <Skeleton
              key={JSON.stringify(`${column.field}-${idx}`)}
              style={{ flex: column.flex, height: '40px' }}
              variant="rectangular"
              animation="wave"
            />
          ))}
        </Box>
      ))}
    </>
  );
};
